module.exports = __webpack_public_path__ + "img/ricefield-img-min.ad15198d.jpeg";